import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationEnd,
  NavigationError,
  Router,
  RouterOutlet,
} from '@angular/router';

const CHUNK_RELOAD_KEY = 'jalyss:lazy-chunk-reload-url';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          sessionStorage.removeItem(CHUNK_RELOAD_KEY);
          return;
        }

        if (!(event instanceof NavigationError)) {
          return;
        }

        if (!this.isLazyChunkLoadError(event.error)) {
          return;
        }

        const targetUrl = event.url || '/';

        // Evita loop caso a falha não seja causada por artefato antigo de deploy.
        if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === targetUrl) {
          sessionStorage.removeItem(CHUNK_RELOAD_KEY);
          return;
        }

        sessionStorage.setItem(CHUNK_RELOAD_KEY, targetUrl);
        window.location.assign(targetUrl);
      });
  }

  private isLazyChunkLoadError(error: unknown): boolean {
    const message = error instanceof Error
      ? `${error.name}: ${error.message}`
      : String(error ?? '');

    return /ChunkLoadError|Loading chunk .* failed|Failed to fetch dynamically imported module|Importing a module script failed|Unable to preload CSS/i.test(message);
  }
}
